import React from 'react'
import { createContext, useState, useEffect } from 'react'
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";
import Loading from '../Loaders/Loader';
import axios from "axios"
import * as constants from '../Constants'
const Authcontext = createContext()

export default Authcontext;

export const AuthProvider = ({ children }) => {

    let [authTokens, setAuthtokens] = useState(() => localStorage.getItem('authTokens') ? JSON.parse(localStorage.getItem('authTokens')) : null)
    let [user, setUser] = useState(() => localStorage.getItem('authTokens') ? jwt_decode(localStorage.getItem('authTokens')) : null)
    let [loading, setLoading] = useState(true)
    let navigate = useNavigate()

    let [openalert, setOpenAlert] = useState(false)
    let [alertseverity, setAlertSeverity] = useState('')
    let [alertmsg, setAlertMsg] = useState('')


    // login request
    let loginUser = async (e) => {
        e.preventDefault()
        try {
            
            const response = await axios.post(`${constants.API_URL}/api/token/`, {
                email: e.target.email.value,
                password: e.target.password.value
            });

            if (response.status === 200) {
                const data = response.data;
                setAuthtokens(data);
                setUser(jwt_decode(data.access))
                localStorage.setItem('authTokens', JSON.stringify(data))
                navigate('/', { state: { openalert: true, alertmsg: "logged in successfully", alertseverity: "success" } })

                // if (jwt_decode(response.data.access).is_superuser === 'True') {

                //     navigate('/super/admin/dashboard', { state: { openalert: true, alertmsg: "logged in successfully", alertseverity: "success" } })

                // }
                // else {
                //     navigate('/', { state: { openalert: true, alertmsg: "logged in successfully", alertseverity: "success" } })
                // }
            }
        }
        catch (error) {
            alert("login failed")

        }
    }

    // logout user
    let logoutUser = () => {
        var config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: 'https://ipapi.co/json',
            headers: {}
        };
        setAuthtokens(null)
        setUser(null)
        localStorage.removeItem('authTokens')
    }

    // Update token

    let updateToken = async () => {
        try {
            const response = await axios.post(`${constants.API_URL}/api/token/refresh/`, {
                refresh: authTokens?.refresh
            })
            const data = response.data
            if (response.status === 200) {
                setAuthtokens(data)
                setUser(jwt_decode(data.access))
                let new_auth_token={"access":data.access,"refresh":authTokens?.refresh}
                // console.log(jwt_decode(data.access))
                localStorage.setItem('authTokens', JSON.stringify(new_auth_token))
            }
            setLoading(false)
        }
        catch (error) {
            setLoading(false)
            logoutUser()
        }
      

    }

    let authenticateGuest = async (rtoken) => {
        let response = await fetch(`${constants.API_URL}/api/token/refresh/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ 'refresh': rtoken })
        })

        let data = await response.json()
        // console.log('data:', data)
        if (response.status === 200) {
            setAuthtokens(data)
            setUser(jwt_decode(data.access))
            // console.log(data.refresh)
            localStorage.setItem('authTokens', JSON.stringify(data))
            alert("user authenticated")
        } else {
            // console.log(response)
            logoutUser()
        }

        if (loading) {
            setLoading(false)
        }

    }

    let contextData = {
        user: user,
        updateToken: updateToken,
        authTokens: authTokens,
        loginUser: loginUser,
        logoutUser: logoutUser,
        authenticateGuest: authenticateGuest,
        alertmsg: alertmsg,
        alertseverity: alertseverity,
        openalert: openalert,
        setOpenAlert: setOpenAlert,
        setAlertMsg: setAlertMsg,
        setAlertSeverity: setAlertSeverity

    }


    // Update token
    useEffect(() => {

        if (loading) {
            updateToken()
        }
        let threeMinutes = 1000 * 60 * 3
        let interval = setInterval(() => {
            if (authTokens) {
                updateToken()
            }
        }, threeMinutes)
        return () => clearInterval(interval)
    }, [authTokens, loading])
    return (

        <Authcontext.Provider value={contextData}>
            {loading ? <Loading /> : children}
        </Authcontext.Provider>

    )
}
